import { render, staticRenderFns } from "./EditColDescModal.vue?vue&type=template&id=738873a7&"
import script from "./EditColDescModal.vue?vue&type=script&lang=js&"
export * from "./EditColDescModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738873a7')) {
      api.createRecord('738873a7', component.options)
    } else {
      api.reload('738873a7', component.options)
    }
    module.hot.accept("./EditColDescModal.vue?vue&type=template&id=738873a7&", function () {
      api.rerender('738873a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/EditColDescModal.vue"
export default component.exports